module.exports = __webpack_public_path__ + "img/zone_rule_default.c27f01cf.png";